<template>
    <div class="index">

        <div class="dvTitle">
            <h5 class="title">FacturasSoft</h5>
        </div>

        <img src="../assets/image/svg/LapInvoice.svg" alt="">
    </div>
</template>

<script>
    export default {
        name: "Index",
    }
</script>

<style scoped lang="scss">
    @import "../style/base";

    .index {
        padding: 30px;
        border: 1px solid #e6ebf4;
        border-radius: .25rem;
        background-color: #fff;
        margin: 20px;

        animation-name: fade;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;

        & .dvTitle {
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;
        }
    }
</style>